import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param bomId
 * @param poId
 */
class BOMServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createBOM = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM,
      data: payload,
    });
    return bom;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  createBOMv2 = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM_V2,
      data: payload,
    });
    return bom;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  getBomJobworks = async (payload) => {
    let url = Constants.BOM_V2_JW;
    if(payload?.bomId) url += `?bom_id=${payload?.bomId}`
    const bomJobworks = await Helpers.get({
      url,
    });
    return bomJobworks;
  }

  updateBomJobwork = async (payload) => {
    let url = `${Constants.BOM_V2}/br_line`;
    const updatedJobworks = await Helpers.put({
      url,
      data: payload,
    });
    return updatedJobworks;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateBOM = async (payload) => {
    const bom = await Helpers.put({
      url: Constants.BOM,
      data: payload,
    });
    return bom;
  }

  updateBOMv2 = async (payload) => {
    const bom = await Helpers.put({
      url: Constants.BOM_V2,
      data: payload,
    });
    return bom;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateBOMStatus = async (payload) => {
    const po = await Helpers.put({
      url: Constants.BOM_STATUS,
      data: payload,
    });
    return po;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateBOMWorkflowStep = async (payload) => {
    const po = await Helpers.post({
      url: Constants.BOM_WORKFLOW,
      data: payload,
    });
    return po;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  deleteBOM = async (payload) => {
    const po = await Helpers.delete({
      url: Constants.BOM,
      data: payload,
    });
    return po;
  }

  /**
   * @param {*} orgId
   * @param {*} entityType
   * @param {*} bomId
   * @param {*} page
   * @param tenantId
   * @param orderId
   * @param status
   * @param customerId
   * @param searchKeyword
   * @param productSkuId
   * @param tenantDepartmentId
   * @param {*} limit
   * @return
   */
  getBOM = async (orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, viewType, bomLinesViewType, searchBomByRm) => {
    let url = `${Constants.BOM}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (bomId) url += `bom_id=${bomId}&`;
    if (status) url += `is_active=${status}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (viewType) url += `view_type=${viewType}&`;
    if (bomLinesViewType) url += `bom_lines_view_type=${bomLinesViewType}&`;
    if (searchBomByRm) url += `rm_product_sku_ids=${searchBomByRm}&`;
    const bom = await Helpers.get({ url });
    return bom;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  activateBOM = async (payload) => {
    const bom = await Helpers.post({
      url: Constants.BOM_ACTIVATE,
      data: payload,
    });
    return bom;
  }
  // bulk upload bom

  bulkUploadBOM = async (payload) => {
    const url = `${Constants.BOM}/bulk-upload/v2`;
    const data = new FormData();
    data.append('file', payload?.file || null);
    data.append('uom_mapping', JSON.stringify(payload?.uomMapping) || null);
    data.append('type', payload?.type || null);
    data.append('product_mapping', JSON.stringify(payload?.productNameMapping) || null);
    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  }
}
export default new BOMServices();
